import React, { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';

const InstallPrompt = () => {
  const [showModal, setShowModal] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const cookies = new Cookies();

  const isStandalone = () => {
    return window.matchMedia('(display-mode: standalone)').matches || 
           window.navigator.standalone === true;
  };

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  const isAndroid = () => {
    return /Android/.test(navigator.userAgent);
  };

  useEffect(() => {
    // Don't show anything if already in standalone mode
    if (isStandalone()) {
      return;
    }

    // Check if user has seen the tutorial
    const hasSeenTutorial = cookies.get('kilroy_install_tutorial_seen');

    if (!hasSeenTutorial) {
      // First time - show modal
      setShowModal(true);
    } else {
      // Already seen - show banner
      setShowBanner(true);
    }
  }, []);

  const handleModalClose = () => {
    setShowModal(false);
    setShowBanner(true);
    // Set cookie to never expire (10 years)
    cookies.set('kilroy_install_tutorial_seen', 'true', { 
      path: '/', 
      maxAge: 315360000 
    });
  };

  const handleBannerClick = () => {
    setShowBanner(false);
    setShowModal(true);
  };

  const handleBannerClose = (e) => {
    e.stopPropagation();
    setShowBanner(false);
  };

  const getInstructions = () => {
    if (isIOS()) {
      return (
        <div>
          <p style={{ marginBottom: '15px', fontSize: '16px' }}>
            To add Kilroy to your home screen:
          </p>
          <ol style={{ textAlign: 'left', paddingLeft: '20px', lineHeight: '1.8' }}>
            <li>Tap the <strong>Share</strong> button <span style={{ fontSize: '20px' }}>⎋</span> at the bottom of Safari</li>
            <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
            <li>Tap <strong>"Add"</strong> in the top right</li>
          </ol>
        </div>
      );
    } else if (isAndroid()) {
      return (
        <div>
          <p style={{ marginBottom: '15px', fontSize: '16px' }}>
            To add Kilroy to your home screen:
          </p>
          <ol style={{ textAlign: 'left', paddingLeft: '20px', lineHeight: '1.8' }}>
            <li>Tap the <strong>menu</strong> button <span style={{ fontSize: '20px' }}>⋮</span> in your browser</li>
            <li>Tap <strong>"Add to Home screen"</strong> or <strong>"Install app"</strong></li>
            <li>Tap <strong>"Add"</strong> or <strong>"Install"</strong></li>
          </ol>
        </div>
      );
    } else {
      return (
        <div>
          <p style={{ marginBottom: '15px', fontSize: '16px' }}>
            To add Kilroy to your home screen, use your browser's "Add to Home Screen" or "Install" option.
          </p>
        </div>
      );
    }
  };

  if (!showModal && !showBanner) {
    return null;
  }

  return (
    <>
      {/* Modal */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#282c34',
            borderRadius: '12px',
            padding: '25px',
            maxWidth: '400px',
            width: '100%',
            color: '#ffffff',
            position: 'relative',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)'
          }}>
            <button
              onClick={handleModalClose}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'none',
                border: 'none',
                color: '#ffffff',
                fontSize: '28px',
                cursor: 'pointer',
                padding: '5px',
                lineHeight: '1'
              }}
            >
              ×
            </button>
            
            <h2 style={{ 
              marginTop: 0, 
              marginBottom: '20px',
              fontSize: '22px',
              color: '#4CAF50'
            }}>
              Install App
            </h2>
            
            {getInstructions()}
            
            <button
              onClick={handleModalClose}
              style={{
                marginTop: '20px',
                width: '100%',
                padding: '12px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
            >
              Got it!
            </button>
          </div>
        </div>
      )}

      {/* Banner */}
      {showBanner && (
        <div
          onClick={handleBannerClick}
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#4CAF50',
            color: 'white',
            padding: '15px 50px 15px 15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            zIndex: 9999,
            cursor: 'pointer',
            boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.3)'
          }}
        >
          <span style={{ fontSize: '14px', fontWeight: '500' }}>
            Install App
          </span>
          <button
            onClick={handleBannerClose}
            style={{
              position: 'absolute',
              right: '15px',
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '0',
              lineHeight: '1'
            }}
          >
            ×
          </button>
        </div>
      )}
    </>
  );
};

export default InstallPrompt;
